export default __webpack_public_path__ + "static/media/spinning.422e663c.png";